import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import authReducer from "../features/auth/authSlice";
import { appServiceApi } from "./appServiceApi";
import { authServiceApi } from "./authServiceApi";
import { bsrmAppServiceApi } from "./bsrm/bsrmAppServiceApi";
import { cashCollectionAppServiceApi } from "./cashCollection/cashCollectionAppServiceApi";
import { employeeServiceApi } from "./employeeServiceApi";
import { holidayServiceApi } from "./holidayServiceApi";

type RootState = ReturnType<typeof store.getState>;
type AppDispatch = typeof store.dispatch;

export const store = configureStore({
  reducer: {
    [appServiceApi.reducerPath]: appServiceApi.reducer,
    [bsrmAppServiceApi.reducerPath]: bsrmAppServiceApi.reducer,
    [cashCollectionAppServiceApi.reducerPath]:
      cashCollectionAppServiceApi.reducer,
    [authServiceApi.reducerPath]: authServiceApi.reducer,
    [employeeServiceApi.reducerPath]: employeeServiceApi.reducer,
    [holidayServiceApi.reducerPath]: holidayServiceApi.reducer,
    auth: authReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(authServiceApi.middleware)
      .concat(bsrmAppServiceApi.middleware)
      .concat(cashCollectionAppServiceApi.middleware)
      .concat(appServiceApi.middleware)
      .concat(employeeServiceApi.middleware)
      .concat(holidayServiceApi.middleware),
});

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
